import { useLocalization } from "../../../features/localization/index.js";
import RequestTable_default from "./RequestTable.vue.js";
import CollapsibleSection_default from "../../../components/layout/CollapsibleSection.vue.js";
import { computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, defineComponent, nextTick, openBlock, ref, toDisplayString, unref, useTemplateRef, withCtx, withModifiers } from "vue";
import { ScalarButton } from "@scalar/components/button";
import { ScalarIconPlus } from "@scalar/icons";
import { ScalarCombobox } from "@scalar/components/combobox";
import { ScalarTooltip } from "@scalar/components/tooltip";
//#region src/v2/blocks/request-block/components/RequestParams.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "text-c-2 request-meta-buttons flex whitespace-nowrap opacity-0 group-hover/params:opacity-100 has-[:focus-visible]:opacity-100" };
var _hoisted_2 = {
	key: 0,
	class: "text-c-2 px-3 py-2 text-sm"
};
var _hoisted_3 = {
	key: 1,
	class: "border-t py-1"
};
var _hoisted_4 = { class: "min-w-0" };
var _hoisted_5 = { class: "block break-all" };
var _hoisted_6 = {
	key: 0,
	class: "text-c-2 block text-xs"
};
var RequestParams_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "RequestParams",
	props: {
		rows: {},
		exampleKey: {},
		title: {},
		label: {},
		description: {},
		invalidParams: {},
		globalRoute: {},
		showAddRowPlaceholder: {
			type: Boolean,
			default: true
		},
		environment: {},
		eventBus: {},
		selectExpandedParameters: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"upsert",
		"delete",
		"deleteAll",
		"selectPreset"
	],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const { translate } = useLocalization();
		const showTooltip = computed(() => __props.rows.length > 1);
		const table = useTemplateRef("table");
		const pickerContainer = useTemplateRef("pickerContainer");
		const selectedFields = ref(/* @__PURE__ */ new Set());
		const getFieldKey = (row, name = row.name) => JSON.stringify([
			row.originalParameter?.in,
			row.originalParameter?.name,
			name
		]);
		/** Single-field objects and ordinary parameters keep their existing presentation. */
		const expandedParameters = computed(() => {
			const counts = /* @__PURE__ */ new Map();
			for (const row of __props.rows) if (row.originalParameter?.in === "query" && row.sourceParameterValuePath) counts.set(row.originalParameter, (counts.get(row.originalParameter) ?? 0) + 1);
			return new Set([...counts].filter(([, count]) => count > 1).map(([parameter]) => parameter));
		});
		const isSelectable = (row) => __props.selectExpandedParameters && Boolean(row.sourceParameterValuePath) && expandedParameters.value.has(row.originalParameter);
		/** Keep original indexes: handlers rebuild object values from all rows, including hidden fields. */
		const indexedRows = computed(() => __props.rows.map((row, index) => ({
			row,
			index
		})));
		const visibleRows = computed(() => indexedRows.value.filter(({ row }) => !isSelectable(row) || row.isRequired || row.value !== "" && row.value !== null || selectedFields.value.has(getFieldKey(row))));
		const tableRows = computed(() => visibleRows.value.map(({ row }) => row));
		const availableFields = computed(() => indexedRows.value.filter((entry) => !visibleRows.value.some(({ index }) => index === entry.index)).map(({ row, index }) => ({
			id: getFieldKey(row),
			label: row.name,
			description: row.description,
			index
		})));
		const selectField = async (option) => {
			if (!option) return;
			selectedFields.value.add(option.id);
			await nextTick();
			table.value?.focusValue(visibleRows.value.findIndex(({ index }) => index === option.index));
		};
		/** The appended placeholder belongs after all stored rows, including hidden fields. */
		const getOriginalIndex = (index) => visibleRows.value[index]?.index ?? __props.rows.length + index - visibleRows.value.length;
		const deleteRow = (index) => {
			const originalIndex = getOriginalIndex(index);
			const entry = visibleRows.value[index];
			if (entry) selectedFields.value.delete(getFieldKey(entry.row));
			emit("delete", { index: originalIndex });
		};
		const deleteAll = () => {
			selectedFields.value.clear();
			emit("deleteAll");
		};
		/** Needed for type guard */
		const handleUpserRow = (index, payload) => {
			const { value, ...rest } = payload;
			if (value instanceof File) return;
			const entry = visibleRows.value[index];
			if (entry && isSelectable(entry.row)) selectedFields.value.add(getFieldKey(entry.row, payload.shouldRenameExpandedRow ? payload.name : entry.row.name));
			emit("upsert", getOriginalIndex(index), {
				...rest,
				value: value ?? ""
			});
		};
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(CollapsibleSection_default), {
				class: "group/params",
				itemCount: tableRows.value.length
			}, {
				title: withCtx(() => [createTextVNode(toDisplayString(__props.title), 1)]),
				actions: withCtx(() => [createElementVNode("div", _hoisted_1, [showTooltip.value ? (openBlock(), createBlock(unref(ScalarTooltip), {
					key: 0,
					content: unref(translate)("apiClient.requestParams.clearOptionalParameters"),
					placement: "left"
				}, {
					default: withCtx(() => [createVNode(unref(ScalarButton), {
						"aria-label": unref(translate)("apiClient.requestParams.clearAll", { title: __props.title }),
						class: "pr-0.75 pl-1 transition-none",
						size: "sm",
						variant: "ghost",
						onClick: withModifiers(deleteAll, ["stop"])
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("apiClient.requestParams.clear")), 1)]),
						_: 1
					}, 8, ["aria-label"])]),
					_: 1
				}, 8, ["content"])) : createCommentVNode("", true)])]),
				default: withCtx(() => [
					__props.description ? (openBlock(), createElementBlock("p", _hoisted_2, toDisplayString(__props.description), 1)) : createCommentVNode("", true),
					createVNode(RequestTable_default, {
						ref_key: "table",
						ref: table,
						class: "flex-1",
						columns: [
							"32px",
							"",
							""
						],
						data: tableRows.value,
						environment: __props.environment,
						exampleKey: __props.exampleKey,
						globalRoute: __props.globalRoute,
						invalidParams: __props.invalidParams,
						label: __props.label,
						showAddRowPlaceholder: __props.showAddRowPlaceholder,
						onDeleteRow: deleteRow,
						onNavigate: _cache[0] || (_cache[0] = (route) => __props.eventBus.emit("ui:navigate", route)),
						onSelectPreset: _cache[1] || (_cache[1] = (index, value) => emit("selectPreset", index, value)),
						onUpsertRow: handleUpserRow
					}, null, 8, [
						"data",
						"environment",
						"exampleKey",
						"globalRoute",
						"invalidParams",
						"label",
						"showAddRowPlaceholder"
					]),
					availableFields.value.length ? (openBlock(), createElementBlock("div", _hoisted_3, [createElementVNode("div", {
						ref_key: "pickerContainer",
						ref: pickerContainer,
						class: "mx-2"
					}, [createVNode(unref(ScalarCombobox), {
						inputLabel: unref(translate)("apiClient.requestParams.searchParameters"),
						noResults: unref(translate)("apiClient.requestParams.noParametersFound"),
						options: availableFields.value,
						placeholder: unref(translate)("apiClient.requestParams.searchParameters"),
						placement: "bottom-start",
						resize: "",
						target: pickerContainer.value ?? void 0,
						"onUpdate:modelValue": selectField
					}, {
						option: withCtx(({ option }) => [createElementVNode("span", _hoisted_4, [createElementVNode("span", _hoisted_5, toDisplayString(option.label), 1), option.description ? (openBlock(), createElementBlock("span", _hoisted_6, toDisplayString(option.description), 1)) : createCommentVNode("", true)])]),
						default: withCtx(() => [createVNode(unref(ScalarButton), {
							class: "gap-1.5",
							size: "sm",
							variant: "ghost"
						}, {
							default: withCtx(() => [createVNode(unref(ScalarIconPlus), { class: "size-3.5" }), createTextVNode(" " + toDisplayString(unref(translate)("apiClient.requestParams.addParameter")), 1)]),
							_: 1
						})]),
						_: 1
					}, 8, [
						"inputLabel",
						"noResults",
						"options",
						"placeholder",
						"target"
					])], 512)])) : createCommentVNode("", true)
				]),
				_: 1
			}, 8, ["itemCount"]);
		};
	}
});
//#endregion
export { RequestParams_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=RequestParams.vue.script.js.map